import React, { createRef, useState, useEffect, useRef } from "react";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ExternalDropZone,
  Upload,
  UploadFileInfo,
} from "@progress/kendo-react-upload";
import axios, { AxiosError } from "axios";
import { Label } from "@progress/kendo-react-labels";
import { Loader } from "@progress/kendo-react-indicators";
import { commonBaseUrl, commonImageUrl } from "../../../services/CommonUtil";
import Breadcrumbs from "../../components/Breadcrumbs";

interface ErrorResponseData {
  detail?: string;
}

interface B2BData {
  Id: number;
  B2BServiceName: String;
  B2BServiceDescription: String;
  B2BServicePicture: String;
  B2BServicePrice: number;
  IsActive: boolean;
  IsDelete: boolean;
  CreatedBy: number;
  CreatedOn: String;
  ModifiedBy: number;
  ModifiedOn: String;
}

export const CreateBusinessToBusinessMaster = () => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log(location);
  const [imgExtension, imgExtensionSet] = useState("");
  const baseUrl = commonBaseUrl();
  const imageURL = commonImageUrl();

  const extensionList = [".jpeg", ".png", ".jpg", ".JPEG", ".PNG", ".JPG"];

  // Variables
  const [imageData, setImageData] = useState("");
  const [currentFile, setCurrentFile] = useState<UploadFileInfo>();
  const uploadRefs = createRef<Upload>();

  const hint = (
    <span>Click to select files or Drag and drop files here to upload.</span>
  );
  const note = (
    <span>
      Only JPEG, JPG and PNG files are allowed. The maximum upload size is 2 MB
    </span>
  );

  const [errorFormatMessage, errorFormatMessageSet] = useState("");

  const [name, setName] = useState("");
  const [Description, setDescription] = useState("");
  const [noofsetsavail, setnoofsetsavail] = useState<string>("");

  //update Enabler
  const [update, setUpdate] = useState(false);

  const [loader, setLoader] = useState(false);
  const [errorneme, setErrorName] = useState("");
  const [errordetails, setErrordetails] = useState("");
  const [errorNoofAvail, setErrorNoofAvail] = useState("");

  const [statusDialog, statusDialogSet] = useState(false);
  const [alert, alertSet] = useState("");
  const [alertState, alertStateSet] = useState(false);
  const [errorimageMessage, setErrorimegeMessage] = useState<string>("");
  const [document, setDocument] = useState([]);

  const [b2bData, setB2BData] = useState<B2BData>();

  const hasFetched = useRef(false);

  useEffect(() => {
    // Prevent second call
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (location.state !== null) {
      console.log("check");
      setLoader(true);
      getB2BAPI();
    }
  });

  const getB2BAPI = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}odata/B2BMasterServices(${location.state.infoId})`
      );
      getB2BImageAPI();
      setB2BData(response.data);
      setName(response.data.B2BServiceName);
      setDescription(response.data.B2BServiceDescription);
      setnoofsetsavail(String(response.data.B2BServicePrice));
    } catch (err) {
      console.error(err);
    }
  };

  const getB2BImageAPI = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}odata/DocumentUploads?$filter=refno eq ${location.state.infoId} and contains(reftype, 'B2BServices')`
      );
      const dataDoct = response.data.value;
      setLoader(false);
      if (dataDoct.length > 0) {
        imgExtensionSet(`.${dataDoct[dataDoct.length - 1]["Type"]}`);
        setDocument(dataDoct);
        setUpdate(true);
      } else {
        removeImage();
      }
    } catch (err) {}
  };

  function onSaveRequest(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any },
    onProgress: (uid: string, event: ProgressEvent<EventTarget>) => void
  ): Promise<{ uid: string }> {
    imgExtensionSet("");
    const currentFile = files[0] as UploadFileInfo;
    console.log("The current file -->", currentFile.extension);

    imgExtensionSet(currentFile.extension!);
    setCurrentFile(currentFile);
    const uid = currentFile.uid;
    console.log(currentFile, "121");
    return new Promise<{ uid: string }>((resolve, reject) => {
      if (
        currentFile.validationErrors &&
        currentFile.validationErrors.length > 0
      ) {
        reject({ uid: uid });
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result && typeof reader.result === "string") {
            const base64Result = reader.result.split(",")[1];
            console.log(base64Result, "this< base64");
            setImageData(base64Result);
            resolve({ uid: uid });
          } else {
            reject({ uid: uid });
          }
        };
        reader.onprogress = (data) => {
          onProgress(uid, data);
        };
        reader.onabort = () => {
          reject({ uid: uid });
        };
        reader.onerror = () => {
          reject({ uid: uid });
        };

        reader.readAsDataURL(currentFile.getRawFile!());
      }
    });
  }

  function onRemoveRequest(
    files: UploadFileInfo[],
    options: { formData: FormData; requestOptions: any }
  ): Promise<{ uid: string }> {
    const currentFile = files[0] as UploadFileInfo;
    console.log("The current file  extension is -->", currentFile);
    const uid = currentFile.uid;
    setImageData("");
    return new Promise<{ uid: string }>((resolve) => {
      resolve({ uid: uid });
    });
  }

  const breadCrumbsData = [
    {
      id: "1",
      text: "Masters",
      route: "",
    },
    {
      id: "2",
      text: "B2B Master",
      route: "/masters/b2b/b2blist",
    },
    {
      id: "3",
      text: `${location.state !== null ? "Edit B2B" : "Create B2B"}`,
      route: "",
    },
  ];

  // Date & Time conversion
  const convertToISOFormat = (inputDate: any): string => {
    // Parse the input date string to a Date object
    const dateObj = new Date(inputDate);

    // Extract the individual date components
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0"); // Month is zero-based, so add 1
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const seconds = String(dateObj.getSeconds()).padStart(2, "0");

    // Get the timezone offset in hours and minutes
    const timezoneOffset = -dateObj.getTimezoneOffset(); // In minutes
    const offsetHours = String(Math.floor(timezoneOffset / 60)).padStart(
      2,
      "0"
    );
    const offsetMinutes = String(Math.abs(timezoneOffset % 60)).padStart(
      2,
      "0"
    );

    // Construct the ISO 8601 formatted string with timezone
    const isoFormattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+${offsetHours}:${offsetMinutes}`;

    return isoFormattedDate;
  };

  // Submit action
  const handleSubmit = (e: any) => {
    let formIsValid = true;
    const extMatch = extensionList.some((char) => imgExtension.includes(char));

    if (imageData === "" && update === false) {
      setErrorimegeMessage("Please Select image");
      formIsValid = false;
    } else {
      setErrorimegeMessage("");
      if (!extMatch) {
        errorFormatMessageSet("The Image Format was not allowed");
        formIsValid = false;
      } else {
        errorFormatMessageSet("");
      }
    }

    if (name.trim() === "") {
      setErrorName("b2b name is required");
      formIsValid = false;
    } else {
      setErrorName("");
    }
    if (Description.trim() === "") {
      setErrordetails("b2b description is required");
      formIsValid = false;
    } else {
      setErrordetails("");
    }
    if (noofsetsavail === "" || noofsetsavail === "0") {
      setErrorNoofAvail("Price is 1-999 required");
      formIsValid = false;
    } else {
      setErrorNoofAvail("");
    }

    if (formIsValid) {
      setLoader(true);
      if (location.state !== null) {
        UpdateB2B(e);
      } else {
        createB2B(e);
      }
    } else {
      console.log("Form has errors, cannot submit.");
    }
  };

  // Create
  const createB2B = async (e: any) => {
    const sendListData = {
      b2BServiceName: name,
      b2BServiceDescription: Description,
      b2BServicePrice: Number(noofsetsavail),
      isActive: true,
      isDelete: true,
      createdBy: 0,
      createdOn: convertToISOFormat(new Date()),
      modifiedBy: 0,
      modifiedOn: convertToISOFormat(new Date()),
    };
    console.log(sendListData, "createB2B");

    try {
      const response = await axios.post(
        `${baseUrl}odata/B2BMasterServices`,
        sendListData
      );

      alertStateSet(false);
      uploadDocumentFiles(response.data.Id, true);
    } catch (err) {
      setLoader(false);
      const axiosError = err as AxiosError<ErrorResponseData>; // assert error as AxiosError
      if (axiosError.response && axiosError.response.data) {
        // Accessing the detail message from error response
        const errorDetail =
          axiosError.response.data.detail || "An unexpected error occurred.";
        alertSet(errorDetail);
        setLoader(false);
        alertStateSet(true);
        statusDialogSet(true);
      } else {
        alertSet("Network error or unexpected error.");
        setLoader(false);
        alertStateSet(true);
        statusDialogSet(true);
      }
      // statusDialogSet(true);
      // alertStateSet(false);
    }
  };

  // Update
  const UpdateB2B = async (e: any) => {
    const updateListData = {
      id: b2bData?.Id,
      b2BServiceName: name,
      b2BServiceDescription: Description,
      b2BServicePicture: b2bData?.B2BServicePicture,
      b2BServicePrice: Number(noofsetsavail),
      isActive: true,
      isDelete: true,
      createdBy: 0,
      createdOn: b2bData?.CreatedOn,
      modifiedBy: 0,
      modifiedOn: convertToISOFormat(new Date()),
    };
    console.log(updateListData, "updateListData");
    try {
      const response = await axios.post(
        `${baseUrl}odata/UpdateB2BMasterServices?id=${b2bData?.Id}`,
        updateListData
      );

      alertStateSet(false);
      uploadDocumentFiles(response.data.id, false);
    } catch (err) {
      setLoader(false);
      const axiosError = err as AxiosError<ErrorResponseData>; // assert error as AxiosError
      if (axiosError.response && axiosError.response.data) {
        // Accessing the detail message from error response
        const errorDetail =
          axiosError.response.data.detail || "An unexpected error occurred.";
        alertSet(errorDetail);
        setLoader(false);
        alertStateSet(true);
        statusDialogSet(true);
      } else {
        alertSet("Network error or unexpected error.");
        setLoader(false);
        alertStateSet(true);
        statusDialogSet(true);
      }
    }
  };

  //upload Image
  const uploadDocumentFiles = async (spaceId: String, flow: boolean) => {
    let header = {
      "Content-Type":
        "application/json;odata.metadata=minimal;odata.streaming=true",
      accept: "*/*",
    };
    let uploadData = [
      {
        docUploadGuid: currentFile?.uid,
        docUploadRefType: "B2BServices",
        docUploadRefNo: spaceId,
        docUploadRefSubType: "B2BServices",
        image: [
          {
            value: imageData,
            fileName: currentFile?.name,
            type: currentFile?.extension?.split(".").pop(),
          },
        ],
      },
    ];
    try {
      const response = await axios.post(
        `${baseUrl}odata/JsonUpload`,
        uploadData,
        {
          headers: header,
        }
      );
      if (response.status === 200) {
        if (flow === true) {
          alertSet("B2B created successfully");
        } else {
          alertSet("B2B updated successfully");
        }
        statusDialogSet(true);
        setLoader(false);
      } else {
        statusDialogSet(true);
        setLoader(false);
      }
    } catch (err) {
      console.log(err);
      setLoader(false);
      statusDialogSet(true);
      alertSet("Error please try again");
    }
  };

  // Back
  const navigateBack = () => {
    if (alertState === false) {
      navigate("/masters/b2b/b2blist");
    }
    statusDialogSet(false);
  };

  const backScreen = () => {
    navigate("/masters/b2b/b2blist");
    window.scrollTo(0, 0);
  };

  // Remove data
  const removeImage = () => {
    setImageData("");
    setUpdate(false);
    imgExtensionSet("");
  };

  return (
    <div>
      {loader === true ? (
        <div className="loader">
          <Loader size="large" type={"converging-spinner"} />
        </div>
      ) : (
        <div className="overall-view ">
          <div className="overall-view">
            <Breadcrumbs breadCrumbData={breadCrumbsData} />
            <hr className="hr-border" />
          </div>
          <div className="common-margin-cresate">
            <div className="form-row-create">
              <div className="form-group-new">
                <Label>
                  B2B Service Name <span style={{ color: "red" }}>*</span>
                </Label>
                <Input
                  className="book-dropdown-new"
                  name="name"
                  value={name}
                  placeholder="Enter the B2B Service name"
                  maxLength={25}
                  onChange={(e) => {
                    if (e.value.trim() === "") {
                      setErrorName("B2B Service name is required");
                    } else {
                      setErrorName("");
                    }
                    setName(e.value);
                  }}
                />
                {errorneme && <span style={{ color: "red" }}>{errorneme}</span>}
              </div>
              <div className="form-group">
                <Label>
                  Description of the service{" "}
                  <span style={{ color: "red" }}>*</span>
                </Label>
                <TextArea
                  className="book-input-view"
                  name="description"
                  rows={3}
                  maxLength={150}
                  placeholder="Enter description"
                  value={Description}
                  onChange={(e) => {
                    if (e.value.trim() === "") {
                      setErrordetails("B2b description is required");
                    } else {
                      setErrordetails("");
                    }
                    setDescription(e.value);
                    console.log(e.value);
                  }}
                />{" "}
                {errordetails && (
                  <span style={{ color: "red" }}>{errordetails}</span>
                )}
              </div>
            </div>

            <hr className="hr-border" />

            <div className="form-row-create">
              <div className="form-group no-wheel">
                <Label>
                  Price <span style={{ color: "red" }}>*</span>
                </Label>
                <div className="createRoomTimePicker">
                  <Input
                    type="number"
                    name="percentageBooking"
                    className="book-dropdown-new"
                    value={noofsetsavail === "0" ? "" : noofsetsavail}
                    min={1}
                    onChange={(e) => {
                      const numericValue = Number(e.value);
                      if (e.value === "") {
                        setErrorNoofAvail("Price is required");
                      } else if (
                        numericValue < 0 ||
                        numericValue > 999 ||
                        isNaN(numericValue)
                      ) {
                        setErrorNoofAvail(
                          "Please enter a number between 1 and 999"
                        );
                      } else {
                        setErrorNoofAvail("");
                      }
                      if (e.value.includes("-")) {
                        return;
                      }
                      const regex = /^[0-9]*$/;

                      if (
                        regex.test(e.value) &&
                        Number(e.value) >= 0 &&
                        Number(e.value) <= 999
                      ) {
                        setErrorNoofAvail(""); // Clear error if input is valid
                        setnoofsetsavail(e.value); // Set the value if it's a valid number
                      } else {
                        setErrorNoofAvail(
                          "Please enter a valid number between 1 and 999"
                        );
                      }
                    }}
                    placeholder="Enter Price"
                    style={{ width: "80%", height: "42px" }}
                  />
                </div>
                {errorNoofAvail && (
                  <p style={{ color: "red" }}>{errorNoofAvail}</p>
                )}
              </div>
              <div className="form-group"></div>
            </div>

            <hr className="hr-border" />
            {update === false && (
              <div>
                <Label>
                  B2B Photo <span style={{ color: "red" }}>*</span>
                </Label>
                <ExternalDropZone
                  className="field-space border-file-upload"
                  uploadRef={uploadRefs}
                  customHint={hint}
                  customNote={note}
                />
                <div className="center-view" style={{ paddingTop: "10px" }}>
                  <Upload
                    ref={uploadRefs}
                    restrictions={{
                      maxFileSize: 2000000,
                    }}
                    batch={false}
                    multiple={false}
                    defaultFiles={[]}
                    withCredentials={false}
                    saveUrl={onSaveRequest}
                    removeUrl={onRemoveRequest}
                  />
                  {errorimageMessage && (
                    <div style={{ color: "red" }}>{errorimageMessage}</div>
                  )}
                  {errorFormatMessage && (
                    <div style={{ color: "red" }}>{errorFormatMessage}</div>
                  )}
                </div>
              </div>
            )}

            <hr className="hr-border" />
            {update === false ? (
              <div></div>
            ) : (
              <div>
                <div className="form-group">
                  <Label>B2B Image</Label>
                </div>
                {document[0] !== undefined ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                    }}
                  >
                    <img
                      width="30%"
                      src={`${imageURL}/${
                        document[document.length - 1]["ImagePath"]
                      }`}
                      alt="new"
                    />
                    <Label>
                      {document[document.length - 1]["Name"]}.
                      {document[document.length - 1]["Type"]}
                    </Label>
                    <Button className="delete-text" onClick={removeImage}>
                      Remove image
                    </Button>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            )}
            <hr className="hr-border" />

            <div
              className="center-view"
              style={{
                paddingBottom: "50px",
              }}
            >
              <div className="form-row-area">
                <div className="form-group-area"></div>
              </div>
              <div className="button-group">
                {location.state !== null ? (
                  <Button className="button-view" onClick={handleSubmit}>
                    {loader === false ? "UPDATE" : "Loading..."}
                  </Button>
                ) : (
                  <Button className="button-view" onClick={handleSubmit}>
                    {loader === false ? "CREATE" : "Loading..."}
                  </Button>
                )}
                <Button className="common-button-view" onClick={backScreen}>
                  CANCEL
                </Button>
              </div>
            </div>
            {/* </form> */}
            {statusDialog && (
              <Dialog>
                <div
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignContent: "center",
                  }}
                >
                  <h3>{alert}</h3>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: "30px",
                    }}
                  >
                    <Button
                      className="button-view"
                      onClick={() => navigateBack()}
                    >
                      Ok
                    </Button>
                  </div>
                </div>
              </Dialog>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
